<template>
  <div :class="$style.detailsContainer">
    <div :class="$style.header">
      <button
        :class="$style.header__buttonRight"
        @click="() => $emit('next')"
      >
        <ArrowSVG :class="$style.arrow" />
      </button>

      <button
        :class="$style.header__buttonLeft"
        @click="() => $emit('prev')"
      >
        <ArrowSVG :class="$style.arrow" class="direction--left" />
      </button>

      <div :class="$style.header__text">
        <span :class="$style.header__text__subtitle">Rumo a profissão</span>
        <h3 :class="$style.header__text__title">{{ trail.name }}</h3>
      </div>
    </div>

    <hr>

    <div :class="[$style.container__content, 'mb-5']">
      <div :class="[$style.paragraph__2, $style.mb__80]" v-html="trail.description"></div>

      <div v-if="trail.characteristics" :class="$style.container__content__body">
        <h6 class="mb-0 text-center">CARACTERÍSTICAS</h6>
        <h5 class="mb-4 text-center">DO PROFISSIONAL</h5>

        <section :class="[$style.list__1, $style.mb__44]">
          <div
            :class="[$style.list__item__1]"
            v-for="characteristic in trail.characteristics" :key="characteristic"
          >
            <span :class="$style.list__item__1__counter"></span>
            <span :class="[$style.heading__3]">{{ characteristic }}</span>
          </div>
        </section>
      </div>
    </div>

    <div
      v-if="trail.assignments"
      :class="[$style.container__content, 'mb-5']"
    >
      <div :class="$style.container__content__body">
        <h6 class="mb-0 text-center">PRINCIPAIS</h6>
        <h5 class="mb-4 text-center">ATRIBUIÇÕES</h5>

        <section :class="[$style.list__1, $style.mb__44]">
          <div
            :class="[$style.list__item__2]"
            v-for="item in trail.assignments" :key="item.assignment"
          >
            <span :class="[$style.heading__3]">{{ item.assignment }}</span>
            <p :class="$style.paragraph__4">{{ item.description }}</p>
          </div>
        </section>
      </div>
    </div>
  
    <h6 class="mb-0 text-center">CONTEÚDO PARA</h6>
    <h5 class="mb-4 text-center">A TRILHA</h5>

    <section :class="$style.mb__20">
      <HorizontalCarousel :items="trail.courses">
        <template v-slot="{ item }">
          <CourseThumbBox
            :only-thumb="true"
            :no-link="true"
            :has-hover="false"
            :course="item"
            class="course-thumb-box"
          />
        </template>
      </HorizontalCarousel>
    </section>

    <div :class="$style.container__content">
      <section :class="$style.mb__44">
        <h5 class="text-center mb-4">
          {{ trail.courses.length }} cursos totalizando {{ trail.trail_duration }} de conteúdo com {{ trail.authors.length }} especialistas diferentes
        </h5>

        <div :class="$style.teachers">
          <div
            v-for="author in trail.authors"
            :key="author.avatar"
            :class="$style.teachers__item"
            :style="`background-image: url(${author.avatar})`"
          ></div>
        </div>
      </section>

      <div :class="$style.button__1" class="text-center">
        <PrimaryButton @click="pickTrail">
          Seguir a trilha {{ trail.name }}
        </PrimaryButton>
      </div>
    </div>
  </div>
</template>

<script>
import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'
import CourseThumbBox from '@/components/course/CourseThumbBox'
import ArrowSVG from "@/components/svg/ArrowSVG"
import PrimaryButton from '@/components/buttons/PrimaryButton'
import { mapGetters, mapMutations } from 'vuex'
import { useUserTrail } from './trail'

export default {
  name: 'TrailDetails',
  props: {
    trail: { type: Object, required: true }
  },
  components: {
    HorizontalCarousel,
    CourseThumbBox,
    ArrowSVG,
    PrimaryButton,
  },
  computed: {
    ...mapGetters('user', ['hasUserSubscriptionAccess']),
  },
  methods: {
    ...mapMutations('app', ['setLoading']),
    ...mapMutations('user', ['setUserTrail']),
    async pickTrail() {
      if (!this.hasUserSubscriptionAccess) {
        this.$router.push({ name: 'subscribe' })

        this.$gtm.trackEvent({ event: 'trail.pick.guest', item_id: this.trail.id })

        return null
      }

      this.$gtm.trackEvent({ event: 'trail.pick.subscriber', item_id: this.trail.id })

      const { changeUserTrail } = useUserTrail()

      this.setLoading(true)

      await changeUserTrail(this.trail.id)

      this.setUserTrail(this.trail.id)

      this.setLoading(false)

      this.$router.push({ name: 'trail.my' })
    }
  },
  
}
</script>

<style module lang="scss">
  @import "~@/components/trail/trail.scss";

  .teachers {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    flex-wrap: wrap;
  }
    
  .teachers__item {
    width: 55px;
    height: 55px;
    background-size: cover;
    background-color: $purple700;
    border-radius: 100%;
    border: 1px solid $white300;
    margin-left: -5px;
  }

  %button {
    float: right;
    width: 50px;
    height: 50px;
  }

  .header__buttonRight {
    @extend %button;
  }
  .header__buttonLeft {
    @extend %button;
  }
</style>